import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react'
import type { Bottega } from '@velasca/types'

const BottegaContext = createContext<Bottega | null>(null)

export const useBottega = () => useContext(BottegaContext)

interface BottegaProviderProps {
  children: ReactNode
}

const BottegaProvider = ({ children }: BottegaProviderProps) => {
  const [currentUserLocation, setCurrentUserLocation] = useState<
    Bottega['currentUserLocation'] | object
  >({})
  const [currentCityGroup, setCurrentCityGroup] = useState('')

  const setCity = useCallback(
    (string: string) => {
      setCurrentCityGroup(currentCityGroup !== string ? string : '')
    },
    [currentCityGroup],
  )

  return (
    <BottegaContext.Provider
      value={{
        currentCityGroup,
        currentUserLocation,
        setUserLocation: setCurrentUserLocation,
        setCity,
      }}
    >
      {children}
    </BottegaContext.Provider>
  )
}

export default BottegaProvider
